export enum FetchStatus {
    IDLE = 'IDLE',
    PENDING = 'PENDING',
    PAGING_PENDING = 'PAGING_PENDING',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
}
